( function () {
	'use strict';

	// Generate all slots 07:00–21:00 dynamically
	var ALL_SLOTS = [];
	for ( var _h = 7; _h <= 20; _h++ ) {
		var _s = ( _h     < 10 ? '0' : '' ) + _h       + ':00';
		var _e = ( _h + 1 < 10 ? '0' : '' ) + ( _h + 1 ) + ':00';
		ALL_SLOTS.push( _s + ' - ' + _e );
	}

	function todayStr() {
		var d = new Date();
		return d.getFullYear() + '-' +
			String( d.getMonth() + 1 ).padStart( 2, '0' ) + '-' +
			String( d.getDate() ).padStart( 2, '0' );
	}

	document.querySelectorAll( '.ccb-form-wrapper' ).forEach( function ( wrapper ) {

		var dateInput  = wrapper.querySelector( 'input[name="booking-date"]' );
		var timeSelect = wrapper.querySelector( 'select[name="time-slot"]' );
		var phoneInput = wrapper.querySelector( 'input[name="phone"]' );

		/* ── Phone: numbers only, exactly 10 digits ── */
		if ( phoneInput ) {
			phoneInput.setAttribute( 'maxlength', '10' );
			phoneInput.setAttribute( 'inputmode', 'numeric' );
			phoneInput.setAttribute( 'pattern', '[0-9]{10}' );

			phoneInput.addEventListener( 'input', function () {
				phoneInput.value = phoneInput.value.replace( /\D/g, '' ).slice( 0, 10 );
				phoneInput.setCustomValidity( '' );
			} );

			phoneInput.addEventListener( 'blur', function () {
				if ( phoneInput.value.length > 0 && phoneInput.value.length !== 10 ) {
					phoneInput.setCustomValidity( 'Please enter a valid 10-digit mobile number.' );
					phoneInput.reportValidity();
				} else {
					phoneInput.setCustomValidity( '' );
				}
			} );
		}

		/* ── Date: disable past dates ── */
		if ( dateInput ) {
			dateInput.setAttribute( 'min', todayStr() );

			dateInput.addEventListener( 'change', function () {
				if ( dateInput.value < todayStr() ) {
					dateInput.setCustomValidity( 'Please select today or a future date.' );
					dateInput.reportValidity();
				} else {
					dateInput.setCustomValidity( '' );
				}
				filterTimeSlots();
			} );
		}

		/* ── Time: filter slots based on selected date ── */
		function filterTimeSlots() {
			if ( ! timeSelect ) { return; }

			var isToday = ! dateInput || ! dateInput.value || dateInput.value === todayStr();
			var nowHour = parseInt( wrapper.dataset.serverHour, 10 );
			var prevValue = timeSelect.value;

			// Clear all options
			timeSelect.length = 0;

			ALL_SLOTS.forEach( function ( slot ) {
				var startHour = parseInt( slot.split( ':' )[0], 10 );

				// If today, hide slots whose start hour has already passed
				if ( isToday && startHour <= nowHour ) { return; }

				var opt = document.createElement( 'option' );
				opt.value = slot;
				opt.textContent = slot;
				timeSelect.appendChild( opt );
			} );

			// Restore previous selection if still available
			var found = false;
			for ( var i = 0; i < timeSelect.options.length; i++ ) {
				if ( timeSelect.options[ i ].value === prevValue ) {
					timeSelect.value = prevValue;
					found = true;
					break;
				}
			}
			if ( ! found && timeSelect.options.length ) {
				timeSelect.selectedIndex = 0;
			}
		}

		// Run once on load
		filterTimeSlots();
	} );

	/* ── Block submission if past date or invalid phone ── */
	document.addEventListener( 'wpcf7beforesubmit', function ( event ) {
		var wrapper = event.target.closest( '.ccb-form-wrapper' );
		if ( ! wrapper ) { return; }

		var dateInput  = wrapper.querySelector( 'input[name="booking-date"]' );
		var phoneInput = wrapper.querySelector( 'input[name="phone"]' );

		if ( dateInput && dateInput.value && dateInput.value < todayStr() ) {
			event.preventDefault();
			event.stopImmediatePropagation();
			dateInput.setCustomValidity( 'Please select today or a future date.' );
			dateInput.reportValidity();
			dateInput.classList.add( 'wpcf7-not-valid' );
			return;
		}

		if ( phoneInput && phoneInput.value.replace( /\D/g, '' ).length !== 10 ) {
			event.preventDefault();
			event.stopImmediatePropagation();
			phoneInput.setCustomValidity( 'Please enter a valid 10-digit mobile number.' );
			phoneInput.reportValidity();
			phoneInput.classList.add( 'wpcf7-not-valid' );
		}
	}, true );
} )();
